import {FC, useCallback, useEffect, useState} from 'react'
import {Col, Form, Row} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import ReactSelect from 'react-select'
import {useAppDispatch, useAppSelector} from 'src/redux/hooks'
import {setSoItem, soSelector} from 'src/redux/slices/soSlices'
import {TOrderItemSO} from 'src/redux/types'
import {fetchSlocList} from 'src/services/fetcher'

type TOption = {value: string; label: string; sloc_description: string}

interface Props {}

export const SelectStorageLocation: FC<Props> = () => {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {orderItem, soItem} = useAppSelector(soSelector)

  const [options, setOptions] = useState<TOption[]>([])
  const [selected, setSelected] = useState<TOption | null>(null)

  const handleChange = (option: TOption | null) => {
    if (!option) return
    const {value: sloc, sloc_description} = option as TOption
    setSelected(option)
    dispatch(setSoItem({...soItem, sloc, sloc_description}))
  }

  const onFetchSlocList = useCallback(async () => {
    if (!orderItem && !soItem) return
    const plant = soItem?.plant ?? ''
    const {order_sub_detail} = orderItem as TOrderItemSO
    const material_number = order_sub_detail?.material_number ?? ''
    const product_type = order_sub_detail?.product_type ?? ''
    const res = await fetchSlocList({material_number, plant, product_type})

    setOptions(
      res.data.data.map((item: any) => ({
        value: item.sloc,
        label: `${item.sloc}-${item.sloc_description}`,
        sloc_description: item.sloc_description,
      }))
    )
  }, [orderItem?.order_sub_detail, soItem?.plant])

  useEffect(() => {
    onFetchSlocList()
  }, [onFetchSlocList])

  useEffect(() => {
    if (options.length === 0) return
    if (!soItem) return
    const option = options?.find((item) => item.value === soItem?.sloc) ?? null
    setSelected(option)
  }, [options])

  return (
    <Row className='mb-3'>
      <Col md={4}>
        <Form.Label className='mt-3'>{t('storage location')}</Form.Label>
      </Col>
      <Col md={8}>
        <ReactSelect
          placeholder={t('pilih')}
          options={options}
          value={selected}
          onChange={(option: any) => handleChange(option as TOption | null)}
        />
      </Col>
    </Row>
  )
}
